'use client';

import { Justify, Text, TextLevels, TypographyBold, View } from '@bytel/trilogy-react';

import { ProductChildFull } from '@app-types/product';

import { InlinePrice } from '@components/inline-price';

import { PricesDetails, sendProductPhonePriceRecapTracking } from '@product-detail/helpers';

type TicketProductProps = {
    currentProduct: ProductChildFull;
    onClickDetail: () => void;
    prices: PricesDetails;
    isRenewal: boolean;
};

export function TicketProduct({ currentProduct, onClickDetail, prices, isRenewal }: Readonly<TicketProductProps>) {
    const { productPrices } = prices;

    const handleGetPriceDetail = () => {
        onClickDetail();
        sendProductPhonePriceRecapTracking(isRenewal, 'Voir le détail du prix');
    };

    const hasOdr = Boolean(Math.abs(productPrices.odrRefund) > 0);

    return (
        <>
            <View flexable justify={Justify.SPACE_BETWEEN}>
                <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.TWO} data-cy='product-name'>
                    {currentProduct.parentTitle}
                </Text>
                {productPrices.marketingAmount > 0 && (
                    <InlinePrice
                        level={TextLevels.TWO}
                        amount={productPrices.marketingAmount}
                        data-cy='marketing-price'
                    />
                )}
            </View>
            <View flexable justify={Justify.SPACE_BETWEEN}>
                <Text level={TextLevels.THREE} marginless={!!currentProduct.ecoTax}>
                    Prix à payer aujourd&apos;hui
                </Text>
                <Text level={TextLevels.THREE} marginless={!!currentProduct.ecoTax}>
                    <InlinePrice
                        typo={[]}
                        level={TextLevels.TWO}
                        amount={productPrices.todayPrice}
                        data-cy='direct-price'
                    />
                </Text>
            </View>
            {currentProduct.ecoTax && (
                <View flexable justify={Justify.SPACE_BETWEEN}>
                    <Text level={TextLevels.FOUR}>dont {currentProduct.ecoTax}&nbsp;€ d&apos;éco-participation</Text>
                </View>
            )}
            {hasOdr && (
                <View flexable justify={Justify.SPACE_BETWEEN}>
                    <Text level={TextLevels.THREE}>Après remboursement sur demande</Text>
                    <Text level={TextLevels.THREE}>
                        <InlinePrice typo={[]} level={TextLevels.TWO} amount={productPrices.odrRefund} />
                    </Text>
                </View>
            )}
            <Text level={TextLevels.TWO}>
                <button className='link button-clear' onClick={handleGetPriceDetail}>
                    Voir le détail du prix
                </button>
            </Text>
        </>
    );
}
